var render = function render(){var _vm=this,_c=_vm._self._c;return _c('Checkbox',{attrs:{"value":_vm.val,"title":_vm.title,"err-msg":_vm.errMsg,"color":_vm.color,"disabled":_vm.disabled,"round":_vm.round,"stop-propagation":_vm.stopPropagation,"icon":_vm.icon},on:{"input":_vm.clicked}})
}
var staticRenderFns = []

export { render, staticRenderFns }